import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useIsPrivacyModeEligible = (): boolean => {
	const { edition } = useSessionData();
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	return edition === ConfluenceEdition.PREMIUM && fg('ccir_privacy_mode');
};
